@if (aberto()) {
    <!-- z-[60] fica acima do lc-modal-confirmation (z-50): o termo nunca pode
         ser encoberto por outro modal. -->
    <div
        class="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-60 p-4"
        role="dialog"
        aria-modal="true"
        aria-labelledby="location-disclosure-title"
    >
        <div
            class="bg-white dark:bg-[#0e1726] rounded-lg shadow-lg w-full sm:max-w-lg max-h-[90vh] overflow-y-auto"
        >
            <!-- Header -->
            <div class="p-4 sm:p-5 border-b border-gray-200 dark:border-[#1b2e4b]">
                <div class="flex items-start gap-3">
                    <icon-map-pin class="w-7 h-7 flex-shrink-0 text-blue-600 dark:text-blue-400" />
                    <h2
                        id="location-disclosure-title"
                        class="text-lg sm:text-xl font-bold text-gray-900 dark:text-white"
                    >
                        @if (contexto() === 'ronda') {
                            Uso da sua localização em segundo plano
                        } @else {
                            Política de Privacidade e uso dos seus dados
                        }
                    </h2>
                </div>
            </div>

            <!-- Body -->
            <div class="p-4 sm:p-5 space-y-4 text-sm text-gray-700 dark:text-gray-300">
                @if (contexto() === 'ronda') {
                    <!-- Aberto pela tela de ronda: direto ao ponto da localização. -->
                    <p>
                        O InfraSeg coleta dados de localização para registrar as rondas e a posição
                        do vigilante em tempo real,
                        <strong class="font-semibold text-gray-900 dark:text-white"
                            >mesmo quando o app está fechado ou não está em uso</strong
                        >.
                    </p>

                    <ul class="list-disc list-outside pl-5 space-y-1.5">
                        <li>Registrar o trajeto e os pontos de ronda durante o turno.</li>
                        <li>
                            Permitir que a central acione o profissional mais próximo em ocorrências.
                        </li>
                        <li>Gerar relatórios de cobertura para a empresa contratante.</li>
                    </ul>

                    <p>
                        Os dados de localização são enviados somente à central da empresa, não são
                        vendidos nem compartilhados com terceiros para publicidade. Você pode
                        desativar a permissão a qualquer momento nas configurações do dispositivo.
                    </p>
                } @else {
                    <!-- Primeiro acesso, fora da ronda: visão geral da privacidade,
                         com o segundo plano incluído entre os usos. -->
                    <p>
                        Para operar o serviço de segurança patrimonial, o InfraSeg coleta e trata
                        seus dados — identificação profissional, registros de turno e ronda,
                        ocorrências, fotos enviadas e localização.
                    </p>

                    <ul class="list-disc list-outside pl-5 space-y-1.5">
                        <li>Registrar turnos, rondas, checklists e ocorrências do seu trabalho.</li>
                        <li>
                            Coletar sua
                            <strong class="font-semibold text-gray-900 dark:text-white"
                                >localização em segundo plano, mesmo com o app fechado ou não em
                                uso</strong
                            >, para registrar o trajeto das rondas e acionar o profissional mais
                            próximo em ocorrências.
                        </li>
                        <li>Enviar notificações operacionais e alertas de emergência.</li>
                        <li>Gerar relatórios para a empresa contratante.</li>
                    </ul>

                    <p>
                        Seus dados são enviados somente à central da empresa, não são vendidos nem
                        compartilhados com terceiros para publicidade. Você pode desativar as
                        permissões a qualquer momento nas configurações do dispositivo.
                    </p>
                }

                <a
                    [href]="politicaPrivacidadeUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="inline-block text-blue-600 dark:text-blue-400 underline font-medium"
                >
                    Política de Privacidade
                </a>
            </div>

            <!-- Footer -->
            <div
                class="p-4 sm:p-5 border-t border-gray-200 dark:border-[#1b2e4b] flex flex-col-reverse sm:flex-row sm:justify-end gap-2 sm:gap-3"
            >
                <button
                    type="button"
                    (click)="recusar()"
                    [disabled]="ocupado()"
                    class="btn px-5 py-2.5 rounded border font-semibold bg-white dark:bg-transparent border-gray-400 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 disabled:opacity-60"
                >
                    Agora não
                </button>
                <button
                    type="button"
                    (click)="aceitar()"
                    [disabled]="ocupado()"
                    class="btn px-5 py-2.5 rounded border font-semibold bg-green-600 text-white border-green-600 hover:bg-green-700 disabled:opacity-60"
                >
                    Aceitar e continuar
                </button>
            </div>
        </div>
    </div>
}
